import { render, staticRenderFns } from "./xskManage.vue?vue&type=template&id=5333184f&scoped=true"
import script from "./xskManage.vue?vue&type=script&lang=js"
export * from "./xskManage.vue?vue&type=script&lang=js"
import style0 from "./xskManage.vue?vue&type=style&index=0&id=5333184f&prod&lang=less"
import style1 from "./xskManage.vue?vue&type=style&index=1&id=5333184f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5333184f",
  null
  
)

export default component.exports